module.exports = __webpack_public_path__ + "static/media/google.cd839006.png";